module.exports = function ($state, recipeListsService, shopper) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.count = 0;

            function initialiseKeptRecipeCount() {
                return shopper.IsGuest
                    ? recipeListsService.initialiseCountForGuestUser()
                    : recipeListsService.getSavedRecipes(1, 1, 'Name');
            }

            // Populate the kept recipes count
            initialiseKeptRecipeCount();

            scope.$watch(() => recipeListsService.keptRecipesCount, () => {
                scope.count = recipeListsService.keptRecipesCount;

                scope.url = recipeListsService.keptRecipesCount > 0
                    ? $state.href('shop.recipes.savedList', null, { inherit: false })
                    : $state.href('shop.recipes.noSavedRecipes', null, { inherit: false });

                if (scope.count <= 0 && $state.includes('shop.recipes.savedList')) {
                    $state.go('shop.recipes.noSavedRecipes', null, { location: 'replace', inherit: false });
                }

                if (scope.count > 0 && $state.includes('shop.recipes.noSavedRecipes')) {
                    $state.go('shop.recipes.savedList', null, { location: 'replace', inherit: false });
                }
            });
        },
        template: require('./recipe-savedList-navigation.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-savedList/recipe-savedList-navigation.directive.js